import styled from "@emotion/styled";

import { fontRoboto, setFullViewportWidthStyles, theme } from "shared/lib/styles";

export const Container = styled.div`
  ${setFullViewportWidthStyles()}
  block-size: 39px;
  max-inline-size: 1208px;
  padding-block: 12px;
  padding-inline-start: 20px;

  font-size: 11px;
  font-family: ${fontRoboto};
  line-height: 13px;
  border-block-end: 1px solid #333333;

  ${theme.breakpoints.up("tablet")} {
    inset-inline: auto;

    display: flex;
    justify-content: center;

    inline-size: 100%;
    margin-inline: 0;
  }

  ${theme.breakpoints.up("desktop")} {
    block-size: 47px;
    padding-block: 16px;

    font-size: 12px;
    line-height: 14px;
  }
`;
